import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';

export const getUploadAnalyticsBase = (): Record<string, string> => {
    const { platform, idfv, network } = getQueryParams();

    const data: Record<string, string> = {
        platform: platform || (IS_MOBILE_BROWSER ? 'mobile_web' : 'desktop_web'),
    };

    if (idfv) {
        data.idfv = idfv;
    }
    if (network) {
        data.network = network;
    }

    return data;
};
